var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-listado',[_c('page-header',{attrs:{"title":"Repositorio Comercial"}}),_c('tabla',{attrs:{"repositorios-comerciales":_vm.repositoriosComerciales},on:{"eliminar":_vm.eliminar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }